/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  [C1f §4] WHICH POLICY A NEW DUTY POINT OPENS ON.
 *
 *  ⚠️ THE INPUT IS THE **ACTIVE** LIST, AND THAT IS WHERE §4's TWO REFUSALS ALREADY LIVE.
 *  The builder filters to `archivedAt === null && currentVersionId !== null` before this is
 *  called, so an ARCHIVED default is simply not in the array and `find` answers `undefined` —
 *  the field stays empty rather than guessing, which is what §4 asks for. Re-testing it here
 *  would be a second expression of a filter that already exists.
 *
 *  ⚠️ AND "NO DEFAULT" IS ALSO `undefined`, not the first policy. Picking one for the
 *  operator because there happened to be one is exactly the guess §4 forbids.
 *
 *  ⚠️ ONE ACTIVE POLICY IS TAKEN EVEN IF NOTHING IS FLAGGED, because a one-option picker is
 *  not a choice — that arm predates C1f and is unchanged.
 *
 *  ⚠️ IT DOES NOT PIN A VERSION, AND MUST NOT. [PRE-P6 §3a] removed the client pinning a
 *  `policyVersionId` out of a 30-second-stale list; omitting the field is what asks the SERVER
 *  to resolve the current published one, and the server is the only thing that can answer.
 * ─────────────────────────────────────────────────────────────────────────────────
 */
export const defaultPolicyFor = (policies: readonly { id: string; isDefault: boolean }[]): string | undefined =>
  policies.length === 1 ? policies[0]?.id : policies.find((row) => row.isDefault)?.id;
